// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1TUWA","package_detail":"styles_package_detail__1k0El","price":"styles_price__AE4jQ"};